<template>
<div class="chapter">
<div class="inner_page">
<div style="page-break-before: always;"></div>
<h1 class="P_Heading_1__And__Page_Break" id="auto_bookmark_toc_1"><span>The More the Merrier</span></h1>
<p class="P_Normal"> </p>
<p class="P_Norm-NoIndent">By Sean Michael</p>
<p class="P_Norm-NoIndent">The Teddy Bear Club</p>
<p class="P_Normal"> </p>
<p class="P_Normal">Too much of a good thing?</p>
<p class="P_Normal">When Logan gets the call about newborn triplets in need of a home, he steps up, realizing too late the daunting task he’s taken on. He’d be lost without the men of the Teddy Bear Club—especially Dirk.</p>
<p class="P_Normal">Dirk even offers to spend spring break at Logan’s home, helping him and the babies settle in. He loves being a dad, and he wants to help Logan find the same joy. It doesn’t hurt that they enjoy spending time together.</p>
<p class="P_Normal">Before they even realize it, they’re settling into a routine… becoming a family.</p>
<p class="P_Normal">Falling in love.</p>
<p class="P_Normal">But their new bond is about to face the ultimate test. Will they come through and realize that with love, there’s no such thing as enough?</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// section0003.vue?73ece6fb